import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { homePathForUser } from '../utils/roles.js';

/** @deprecated Use role-based home paths */
export function DashboardPage() {
  const { user } = useAuth();
  return <Navigate to={homePathForUser(user)} replace />;
}
